import { forwardRef } from "react";
import { cn } from "~/design-system/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error: boolean;
  allowWhitespace?: boolean;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ className, error, allowWhitespace, ...props }, ref) => {
    return (
      <input
        className={cn(
          "h-[62px] w-full rounded-full border border-alto bg-white px-6 py-3 outline-none transition-colors placeholder:text-lg placeholder:font-light placeholder:text-emperor/50 focus:border-black focus-visible:ring-0 max-md:h-[50px] max-md:placeholder:text-sm",
          error && "border-red-500",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export { Input };
